var productWizardConstants = require('../Helpers/productWizardConstants');

module.exports = ['$scope', '$state', '$stateParams', '$location', '$anchorScroll', function ($scope, $state, $stateParams, $location, $anchorScroll) {
    // get state from url params
    var activeStyle = '';
    $location.hash('scrollto');

    if (typeof ($stateParams.style) === 'string') {
        activeStyle = $stateParams.style;
    }
    var activePrimaryColor = '';
    if (typeof ($stateParams.primaryColor) === 'string') {
        activePrimaryColor = $stateParams.primaryColor;
    }
    var activeColors = [];
    if (typeof ($stateParams.colors) === 'string') {
        activeColors = $stateParams.colors.split(',');
    }
    // get disabled colors from map based on state
    var disabledColors = [];
    var i = 0;
    for (i = 0; i < MG.colorMap.length; i++) {
        if (MG.colorMap[i].Style === activeStyle && MG.colorMap[i].PrimaryColor === activePrimaryColor) {
            if (typeof (MG.colorMap[i].RejectColors) === 'string')
                disabledColors = MG.colorMap[i].RejectColors.split(',');
        }
    }

    $scope.mode = $stateParams.mode;

    $scope.colorOptions = productWizardConstants.primaryColors;

    $scope.btnColorClass = function (option) {
        var classes = [];
        if (disabledColors.indexOf(option) !== -1) {
            classes.push('disabled');
        } else {
            if ($stateParams.mode === 'like') {
                classes.push('like');
                if (activeColors.indexOf(option) !== -1) {
                    classes.push('active');
                }
            } else if ($stateParams.mode === 'dislike') {
                classes.push('dislike')
                if (activeColors.indexOf(option) !== -1) {
                    classes.push('active');
                }
            }
        }

        return classes.join(' ');
    };

    $scope.btnColorClick = function ($event, option) {
        $event.preventDefault();
        var orderedActiveColors = [];

        if (disabledColors.indexOf(option) !== -1) {
            return;
        }

        if (activeColors.indexOf(option) === -1) {
            activeColors.push(option);
        } else {
            activeColors.splice(activeColors.indexOf(option), 1);
        }

        angular.forEach(productWizardConstants.primaryColors, function (color) {
            if (activeColors.indexOf(color.id) !== -1) {
                orderedActiveColors.push(color.id);
            }
        });

        $stateParams.colors = orderedActiveColors.join(',');
        $state.go('designer-color', $stateParams);
        $location.hash('scrollto');
    };

    $scope.btnBackClick = function ($event) {
        $event.preventDefault();
        if ($stateParams.mode === 'like') {
            $state.go('primary-color', { style: activeStyle, primaryColor: activePrimaryColor });
        } else if ($stateParams.mode === 'dislike') {
            $stateParams.mode = 'like';
            $stateParams.colors = null;
            $state.go('designer-color', $stateParams);
        }
    };

    $scope.btnContinueClass = function () {
        if ($stateParams.mode === 'like' && activeColors.length > 0) {
            return 'active';
        } else if ($stateParams.mode === 'dislike' && activeColors.length > 0 && (activeColors.length + disabledColors.length) < 10) {
            return 'active';
        } else {
            return 'disabled';
        }
    };

    $scope.btnContinueClick = function ($event) {
        var i = 0;
        var colors = [];

        $event.preventDefault();

        if ($stateParams.mode === 'like') {
            colors = activeColors;
        } else if ($stateParams.mode === 'dislike') {
            for (i = 0; i < productWizardConstants.primaryColors.length; i++) {
                if (activeColors.indexOf(productWizardConstants.primaryColors[i].id) === -1
                    && disabledColors.indexOf(productWizardConstants.primaryColors[i].id) === -1) {
                    colors.push(productWizardConstants.primaryColors[i].id);
                }
            }
        }

        $state.go('stone-type', { colors: colors.join(',') });
    };

    $scope.btnDislikeClick = function ($event) {
        $event.preventDefault();
        $stateParams.mode = 'dislike';
        $stateParams.colors = null;
        $state.go('designer-color', $stateParams);
    };
}];
